export const schedulingLabels = {
	scheduleScans: 'Schedule Scans',
	runScanEvery: 'Run scan every',
	amount: 'Select amount',
	periodType: 'Select period type',
	daysToRunScan: 'Days to run scan',
	time: 'Time',
	timezone: 'Timezone',
	startMonth: 'Start Month',
	startTime: 'Start time',
	months: 'Month',
	weeks: 'Week',
	scheduleScansDescription:
		'Set a start time and interval of when and how often scans will automatically be executed.',
	runEvery: 'Run scan every',
	crawlBeforeScan: 'Crawl before scanning',
	nextScanScheduledFor: 'Next scan is scheduled for',
	at: 'at'
};
